import { useOktaAuth } from "@okta/okta-react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import type { ReactNode } from "react";

interface RequireAuthProps {
  children?: ReactNode;
}

export const RequireAuth = ({ children }: RequireAuthProps) => {
  const { authState } = useOktaAuth();
  const location = useLocation();

  // Still loading auth state - show nothing or loading
  if (authState?.isPending) {
    return null;
  }

  // Not authenticated - redirect to login page, remembering where the user
  // was heading so OktaLogin (and okta-react's LoginCallback, which reads
  // the same state) can return them there instead of the default landing.
  if (!authState?.isAuthenticated) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  // Authenticated - render children or Outlet
  if (children) {
    return <>{children}</>;
  }

  return <Outlet />;
};
